import { Maybe } from 'graphql/jsutils/Maybe';
import { TFunction } from 'i18next';
import { StoresField } from 'src/components/common/table/columns/stores';
import { StoreModel } from 'src/graphql/generated/graphql';
import { DevicesField } from '../common/table/columns/devices';
import { DataTableMeta, LimitedContent } from '@otp/ui';
import { ActionsField } from './columns/actions';
import { PartialMostFavouriteListType } from 'src/components/most/list/favourite/types';

export type MostFavourite = {
  id: string;
  jobConfig: {
    name: string;
    description?: Maybe<string>;
    devices: string[];
    stores: Partial<StoreModel>[];
  };
};

export const getTableConfig = (
  data: PartialMostFavouriteListType[],
  { t }: { t: TFunction },
) => [
  {
    name: 'jobConfig.name',
    label: t('most.list.favourite.columns.name'),
    options: {
      setCellProps: () => ({ className: '!max-w-sm' }),
    },
  },
  {
    name: 'jobConfig.stores',
    label: t('most.list.favourite.columns.stores'),
    options: {
      customBodyRender: (value: Partial<StoreModel>[]) => (
        <StoresField stores={value} />
      ),
    },
  },
  {
    name: 'jobConfig.devices',
    label: t('most.list.favourite.columns.devices'),
    options: {
      customBodyRender: (value: string[]) => <DevicesField devices={value} />,
    },
  },
  {
    name: 'jobConfig.description',
    label: t('most.list.favourite.columns.description'),
    options: {
      setCellProps: () => ({ className: 'max-w-lg' }),
      customBodyRender: (value: string) => (
        <LimitedContent maxRows={3}>{value}</LimitedContent>
      ),
    },
  },
  {
    name: 'actions',
    label: ' ',
    options: {
      customBodyRender: (_: any, column: DataTableMeta) => {
        const favourite = data[column.rowIndex];
        if (!favourite) {
          return null;
        }

        return <ActionsField favourite={favourite} />;
      },
    },
  },
];
